<template>
    <div class="proposition-wrap">
       <div v-if="propositionList.length && showPropositionModal" class="proposition-block">
           <div class="proposition-header">
               <b v-if="showPropositions" style="font-size: 20px;">Обрані пропозиції: {{propositionList.length}}</b>
               <div v-else-if="showClientForm && isMobile" style="text-align: center">
                   <b  style="font-size: 20px;">Налаштуйте сторінку</b>
               </div>
               <div v-else-if="showLink && isMobile" style="text-align: center">
                   <b  style="font-size: 19px;">Завершіть формування сторінки</b>
               </div>
               <div v-if="showPropositions" style="float: right;">
                   <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <g clip-path="url(#clip0)">
                           <path d="M13.7921 24.5541L7.76719 14.5118C7.59776 14.2295 7.29257 14.0566 6.96332 14.0566C6.63394 14.0566 6.32882 14.2295 6.15945 14.5118L0.134583 24.5541C-0.0391671 24.8437 -0.0437921 25.2044 0.122708 25.4982C0.289082 25.7922 0.600707 25.9738 0.938519 25.9738H12.9883C13.3261 25.9738 13.6377 25.7922 13.8041 25.4982C13.9704 25.2043 13.9658 24.8437 13.7921 24.5541ZM2.59414 24.0988L6.96326 16.8163L11.3324 24.0988H2.59414Z" fill="#FFAD3D"/>
                           <path d="M13.7916 24.5541L7.7667 14.5118C7.59726 14.2295 7.29208 14.0567 6.96289 14.0566V16.8164L11.332 24.0989H6.96289V25.9739H12.9877C13.3254 25.9739 13.6371 25.7922 13.8035 25.4983C13.9699 25.2043 13.9653 24.8437 13.7916 24.5541Z" fill="#FFAD3D"/>
                           <path d="M12.9873 24.0996H0.937498C0.419749 24.0996 0 24.5194 0 25.0371C0 28.8761 3.12331 31.9992 6.9623 31.9992C10.8014 31.9992 13.9247 28.876 13.9247 25.0371C13.9248 24.5194 13.505 24.0996 12.9873 24.0996Z" fill="#FFAD3D"/>
                           <path d="M31.8662 19.5345L25.8413 9.4923C25.6719 9.20992 25.3667 9.03711 25.0374 9.03711C24.708 9.03711 24.4029 9.20992 24.2335 9.4923L18.2088 19.5345C18.0351 19.8241 18.0304 20.1848 18.1969 20.4788C18.3633 20.7726 18.6749 20.9543 19.0127 20.9543H31.0624C31.4001 20.9543 31.7118 20.7726 31.8782 20.4788C32.0446 20.1848 32.04 19.8241 31.8662 19.5345ZM20.6682 19.0793L25.0374 11.7969L29.4065 19.0793H20.6682Z" fill="#FFAD3D"/>
                           <path d="M31.8658 19.5345L25.8409 9.4923C25.6715 9.20992 25.3664 9.03717 25.0371 9.03711V11.7969L29.4062 19.0793H25.0371V20.9543H31.0618C31.3996 20.9543 31.7113 20.7726 31.8777 20.4788C32.0442 20.1848 32.0397 19.8241 31.8658 19.5345Z" fill="#FFAD3D"/>
                           <path d="M31.0624 19.0781H19.0127C18.4949 19.0781 18.0752 19.4979 18.0752 20.0157C18.0752 23.8546 21.1985 26.9778 25.0375 26.9778C26.8972 26.9778 28.6455 26.2536 29.9607 24.9386C31.2757 23.6236 31.9999 21.8752 31.9998 20.0156C31.9999 19.4979 31.5801 19.0781 31.0624 19.0781Z" fill="#FFAD3D"/>
                           <path d="M31.9656 8.05011C31.827 7.55124 31.3102 7.25917 30.8114 7.39774L16.9375 11.2514V0.937498C16.9375 0.419749 16.5178 0 16 0C15.4823 0 15.0625 0.419749 15.0625 0.937498V11.7722L0.686849 15.7653C0.187912 15.9039 -0.104087 16.4206 0.0344127 16.9195C0.149725 17.3345 0.526537 17.6063 0.937161 17.6063C1.02022 17.6063 1.10472 17.5952 1.1886 17.5719L31.3131 9.20429C31.8121 9.06579 32.1042 8.54898 31.9656 8.05011Z" fill="#B2B4BC"/>
                           <path d="M31.9656 8.05011C31.827 7.55124 31.3102 7.25917 30.8113 7.39774L16.9375 11.2514V0.937498C16.9375 0.419749 16.5177 0 16 0V13.4578L31.3132 9.2043C31.8121 9.06579 32.1042 8.54898 31.9656 8.05011Z" fill="#B2B4BC"/>
                           <path d="M12.9877 24.0996H6.96289V31.9992C10.8019 31.9992 13.9252 28.876 13.9252 25.0371C13.9252 24.5194 13.5054 24.0996 12.9877 24.0996Z" fill="#FFAD3D"/>
                           <path d="M31.0618 19.0781H25.0371V26.9778C26.8969 26.9778 28.6452 26.2536 29.9603 24.9386C31.2753 23.6236 31.9995 21.8752 31.9994 20.0156C31.9993 19.4979 31.5796 19.0781 31.0618 19.0781Z" fill="#FFAD3D"/>
                       </g>
                       <defs><clipPath id="clip0"><rect width="32" height="32" fill="white"/></clipPath></defs>
                   </svg>
               </div>
           </div>


           <div v-if="showPropositions">
<!--               <button v-if="!isMobile" class="hide" @click="show = false">-->
<!--                   <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                       <path d="M17 1L1 17" stroke="black" stroke-width="2"/>-->
<!--                       <path d="M1 1L17 17" stroke="black" stroke-width="2"/>-->
<!--                   </svg>-->
<!--               </button>-->
               <!--            <a href="#" class="change link collapsed" data-toggle="collapse" data-target="#searchcollapse" aria-expanded="false" aria-controls="#searchcollapse" @click="scrollTo('#searchcollapse')">Змінити</a>-->
               <!--            <div class="title d-lg-block">Ваш поліс</div>-->
               <!--            <hr class="d-none d-lg-block">-->


               <div :class="['prop-body', {active: isMobile && showMobileBlock}]">
                   <div class="prop-head">
                       <div class="__head-left">Компанія</div>
                       <div class="__head-right">Франшиза</div>
                       <div style="width: 15px;"></div>
                   </div>
                   <div class="prop-rows">
                       <div v-for="(proposition, key) in propositionList">
                           <div class="prop-row">
                               <div class="company-name" >
                                   {{ proposition.companyName || (proposition.company ? proposition.company.publicName : '') }}
                               </div>
                               <div class="franchise-name">
                                   {{ proposition.franchise }}
                               </div>
                               <div class="prop-remove">
                                   <button @click="removeProposition(proposition)">
                                       <svg width="12" height="12" viewBox="0 0 10 10"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                           <path d="M9 1L1 9" stroke="#000000"/>
                                           <path d="M1 1L9 9" stroke="#000000"/>
                                       </svg>
                                   </button>
                               </div>
                           </div>
                           <hr v-if="key != (propositionList.length - 1)" class="">
                       </div>
                   </div>
                   <div class="prop-buttons">
                       <button v-on:click="clearPropositions()" type="button" class="btn prop-button btn-outline-blue">
                           Очистити
                       </button>
                       <button v-on:click="goNext()" type="button" class="btn prop-button btn-blue">
                           Далі
                       </button>
                   </div>
               </div>
           </div>

           <div v-if="showClientForm" class="client-form" :class="{active: isMobile && showMobileBlock}">
<!--               <b style="font-size: 20px;">Налаштуйте сторінку: {{propositionList.length}}</b>-->
               <div >
                   <div class="field-desc"><div class="fd-number">1.</div ><div class="fd-text"> Оберіть клієнта, якому бажаєте надіслати сторінку пропозицій</div> </div>
                   <div class="form-group tooltip-group surname-block" style="margin-top: 15px">
                       <input v-model="clientName" v-loading="isLoadInsuredsList" type="text" class="form-control surname-field client-input" placeholder="Пошук клієнта"
                              :class="['form-control surname-field', {invalid: (!$v.clientName.required && submitCheck) || (!$v.clientName.minLength)}]"
                       >
                       <div v-if="isLoadInsuredsList" class="load-insured-list spinner-border spinner-border-sm" role="status"></div>
                       <div v-if="insuredsList && insuredsList.length > 0" class="autocomplete-surname">
                           <div @click="selectInsuredInfo(insured)" class="inn-items mb-1 mt-2" v-for="insured in insuredsList">
                               <insureds-list-item :insured="insured"></insureds-list-item>
                           </div>
                       </div>
                       <i class="icon search" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Пошук клієнта"></i>
                   </div>
                   <div class="field-desc"><div class="fd-number">2.</div><div class="fd-text"> Додайте нотатки для згенерованої сторінки</div></div>
                   <div class="form-group" style="margin-top: 15px">
                       <textarea  :class="['form-control', {invalid: (!$v.comment.required && submitCheck) || (!$v.comment.minLength) || (!$v.comment.maxLength)} ]"  v-model="comment"  placeholder="Введіть нотатки"></textarea>
                       <small class="error"
                              v-if="(!$v.comment.maxLength) && submitCheck">Текст повинен містити максимум {{$v.comment.$params.maxLength.max}} символів</small>
                   </div>
                   <div class="prop-buttons">
                       <button v-on:click="clearPropositions()" type="button" class="btn prop-button btn-outline-blue">
                           Скасувати
                       </button>
                       <button v-on:click="generateLink()" type="button" class="btn prop-button btn-blue">
                           Згенерувати
                       </button>
                   </div>
               </div>
           </div>

           <div v-if="showLink" class="client-form" :class="{active: isMobile && showMobileBlock}">
               <div class="block-centered">
                   <div class="text-center"><b style="font-size: 20px;">Сторінку вдало згенеровано</b></div>
                   <div class="qr-box text-center">
                       <img :src="qrcode" alt="">
                   </div>
                   <div class="text-center" style="color: #999DA6;">QR-код переходу на сторінку</div>
                   <div class="link-row form-group">
                       <div class="link-text" style="" >{{ link }}</div>
                       <button @click="copyToBuffer()" class="btn-icon">
                            <svg v-if="!isCopied" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 0.085022H8C6.897 0.085022 6 1.00992 6 2.14722V6.2716H2C0.897 6.2716 0 7.1965 0 8.33379V18.6448C0 19.7821 0.897 20.707 2 20.707H12C13.103 20.707 14 19.7821 14 18.6448V14.5204H18C19.103 14.5204 20 13.5955 20 12.4582V2.14722C20 1.00992 19.103 0.085022 18 0.085022ZM2 18.6448V8.33379H12L12.002 18.6448H2ZM18 12.4582H14V8.33379C14 7.1965 13.103 6.2716 12 6.2716H8V2.14722H18V12.4582Z" fill="#24282C"/>
                            </svg>
                            <svg v-if="isCopied" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <rect width="25" height="25" fill="url(#pattern0_89_3028_copied)"/>
                                <defs><pattern id="pattern0_89_3028_copied" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_89_3028_copied" transform="scale(0.01)"/></pattern>
                                    <image id="image0_89_3028_copied" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFfElEQVR4nO2caYgcRRTHO8Y7K15REbwVhXigKB54LCgbxu33ql6vNHiAYsQgeKEQBEFXEfygoigKBuKuuzOvJkxAMRKJVwz54okohpgPnnhLPGJMSNzsrtTOajbL7nb17szUdPf7QX3t+ff8u+pVVf+rg0AQBEEQBEEQBEEQBEEQBEEQBEEQhGxReq10ADHeQQZfJoZXiOHeuBZ3+NZVSOJa3KEZPyCDoxObZtwEDAt96yscZLBvshl7TIEXfesrFFSFxcQ4Mp0hxLg9GA3m+dZZCNQKdYg2+M20ZtQNGbmpv/NA31oLgWZ8dkYz6nXkM986C4GuhpdrA8OJhlThet9aCzHF1YybkswgxrekfrQAYnw80QyDW6EGJ7RCT6EhDi/UDLuTDYHbfGvNPXEt3t8W6cS6YXC9DFUtQBt82KFubMdBPK0VegoNGjxHM+xKMkQZuMe31tzT+U7nvsTwYXLvgPfiWjzft97coxnvcxiqdqLBM31rzT1Uvfp0zbDDYUV+v2+tuae3t3cfYtzgYMYnS5cv3c+33tyjDd7pMFQNEYfn+9aae3oq3SeSgb8cescjvrXmn9FgnmZ83WEB+LlsrbcAXcFbks2A4Z4KXtoKPYUmKkfHksHfHdYcT/jWWgjIpkaSNw6/6hrsWuBba+4hg9c5zKpGdBWu8q019wDDQm3gF4f3HM/51loIiHGlQ+/41gYbfGvNPVRBcOgZo5HBkm+tuSeuxYdqg985GNLnW2tQ9NQh7Vlz/BhyeLhvrbknMnjljKnD8aZMGPnWmnu6BrsWaINfOvSOqm+thUC7pA4NbIkGo6N9a809xHCJS+rQLhR9a809JcfUoTbwqm+thUAbfCzRDIY/o3LpON9ac48y6jxt4J/koUot8a21KFGejx16x9uZTB3aWGXE4Q3E+KRmfECV1aKgjSEDvQ5mbNNVfVKQNez4SgwbJ93MbptfCtoQXdFnu6QO7SnaIItohjdmeMpeaKdITFyL5091QnYKMzbY2E+QNXRVH59cFOFNu2kXtAHEsMxhqNphA3FBFlFGXeSwoLLvnDfaKE0WUofEsCzIKnFt8RGOq1ybWfpJGXVBW6cODb6f+YC0rRNOvaTe/qYK6lZrjAzc7jBU7YWhmcFWSeuxQeRwTWupowdAWN1d7ulDonhwSAvjM9eEndMJxX75XaB1mxtZHCtgxmfttNssGHYJ9+1poy3tc0MCpBRSxymuEO+altLoAr2OM1mJjydzdi8ixxTh5rh0SDvRGW82DHX9N9T+r2udJ/bSA3E+JLDsLm5MAHpHg5PsYnwFMV+m+awuxG/HbG6NnmKC8PEcFlQJOrrFFyfoqcMzfWQPQ3QkU69k+GpoLBv5QxW0szANOPTs91L0gzGwYyvi/3Jvfqhl4dSTYsZV9k1TpqfiYwKHa47Ehnsat7NZgjFcLPbW7r/x/l341rpqAanDp9v/p1mCBvft++pUxT7L1RZnZF0XTKwwmGo+kH368Nac6cZwh6qT/wc3t415TdVUVfMPXWoVGvvNEOML9w+SlFTdtrXxJOvA6vhYNuLHK4x4OdOMxbhJIOrU5gyYicHE69BDM849LBfXWtR4bEbky5/Ku3d+uxmoGvqUDNcU/g/Oi32c9xpNib12Nlx2OzQq1aJGbNEM5D96FfK3jI6rWkGtqDBY8SQOX7HkBh+boQh0RSTAGEW4CCe7PTVTNDWyN/fgOxx8bIwLpZmrHVRpTEkCZEVMngQHpDwlvFjGZvTHLySrzeYF0mA9JZQ3F4Y2Im187QqnSqb62FIbJ7Vgb+mHZWZeAu3xoLhyqrRVPvXUG/DFWeiGtxh40cESOPJScrCL60CIIgCIIgCIIgCIIgCIIgBO3Iv6h8/J8BCVIQAAAAAElFTkSuQmCC"/>
                                </defs>
                            </svg>
                        </button>
                    </div>
                    <div class=" " :class="['link-row input-row form-group ', {invalid: (!$v.email.required && submitEmail) || (!$v.email.email)}]">

                        <div class="link-text" style="">
                            <input
                            v-model="email"
                            type="text"
                            class="form-control client-input email-input"
                            placeholder="Електронна адреса"
                            :class="['form-control ']"
                             >
                        </div>

                        <button @click="sendMail()" class="btn-icon" v-loading="loadingMail">
                          <svg v-if="!isSendMail" data-v-87891006="" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect data-v-87891006="" width="25" height="25" fill="url(#pattern0_88_2836)"></rect><defs data-v-87891006=""><pattern data-v-87891006="" id="pattern0_88_2836" patternContentUnits="objectBoundingBox" width="1" height="1"><use data-v-87891006="" xlink:href="#image0_88_2836" transform="scale(0.01)"></use></pattern><image data-v-87891006="" id="image0_88_2836" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD2klEQVR4nO3dT4gcRRQG8DIbiRLiPwTZJGTZqdfzaua9rj3MJQZ0vXnS2972YvakF/UQJSR6USEQTwqCnhIVvHnLRbx5y0EI5KQ5KaKYIKtRDNFNQhkG1mVqd2d6evrtzPeDOSzMNN39bVV1V3dVOQcAAAAAAGBQt9t9goK+5YN8VrCcSn83vU8zK518H/QaBb3b//igv/ug7yCYBhQsZzeHgWAa5oN8ngsEJaYBFMo3dwoEwUxQCGHes9zebSj/tTGsNz3LObQxNSGWL4cJBMHUzLM8P0ogCKY+DxDrd1VCQVU2ZtSRN6oGgsZ/jNrt9pM+6K3B//nyFbG8Siy/oMRMELF+kQnkn6JYOhJjPIhgJsizPLdNCXi7/z0EM0HEenVwuyA/Orcyt/m7CGYCKMhr+auo7ouDfoNgarSwtPQYsfw1MBSWS9v9FsHUhFgvZErJRrsdF3f6PYIZMx/06W0a9/d2ux0EM0ae9dvB1Zb+3Ov1HhxmWwhmDKgtL2dLCZcro2wz4j5mdMx8yAf9I9O4f11h0w7BjIiCfJwpJXcWQ2xXCSVBMEMqClnKN+7yvhuTiKps9yjo5UxX+42FhYWHxhVKgmB2gTqyli0lbV11NYgoMXlHjx5/mFh+y4TyTR2B9CGYDAryQa6UtLgsXc0iSsz/FYV00pVV5hL4w7oD6UMwm6TqKXO1tZ5OlJugiBKT7tx1Ndu4d2RtkoH0zXQwRHTAB/k1c5CXm9y3OKvBUNDz2YMLZa/p/YuzFgyR+Hzjrp84I+IsBZM6FgcfjPxJRI84Q+IsBJO63rfp33rFGRSnOZjl5eX9PuhPmUCuOMPitAZDQd/N77yccMbFaQum1e0eoyD/Zhr3i26PiNMUTHolKLPDf6f+raIoW5P6MPNh59y+ik9HT/ug14cKxtLgWGJ5YZidr/vjg14rOuWzVY6pSjDE+pJr1socsf7QdBC05cQsqj5V9chGDOZO0SmfcU1Kkw00HQLV2K82bDA+6EeuSSYDYT05o4HYq7IoyHqDVdZGo1WWtUadWL+vekL2dKNu6bI3hDCfBq7O7GUvbgzV1o0huk66NoJI0LloDLrfjcEDKkPwCNcYvORgCF4DMgYvyhmDV0kNwcvWxmA4giEYsGMMhrQZg0GfhmBYtDGYOMAQTK1hDCafMQbTMxmCCcyMwRR/hmASTGMwTawxmEjZEEw1bgwm4zcEy1UYgwVdbMGSR5ZgUTBjsGyeIVhY0pi0XPeeGzE0zYj1UwRhiGc5gxJhyLGyfHzrKp+omhrWavUeTaNQ77/U0H0dbQQAAAAAAICbGvcAAaOp6BYsyYQAAAAASUVORK5CYII="></image></defs></svg>

                          <svg v-if="isSendMail" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <rect width="25" height="25" fill="url(#pattern0_89_3028)"/>
                            <defs><pattern id="pattern0_89_3028" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_89_3028" transform="scale(0.01)"/></pattern>
                              <image id="image0_89_3028" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFfElEQVR4nO2caYgcRRTHO8Y7K15REbwVhXigKB54LCgbxu33ql6vNHiAYsQgeKEQBEFXEfygoigKBuKuuzOvJkxAMRKJVwz54okohpgPnnhLPGJMSNzsrtTOajbL7nb17szUdPf7QX3t+ff8u+pVVf+rg0AQBEEQBEEQBEEQBEEQBEEQBEEQhGxReq10ADHeQQZfJoZXiOHeuBZ3+NZVSOJa3KEZPyCDoxObZtwEDAt96yscZLBvshl7TIEXfesrFFSFxcQ4Mp0hxLg9GA3m+dZZCNQKdYg2+M20ZtQNGbmpv/NA31oLgWZ8dkYz6nXkM986C4GuhpdrA8OJhlThet9aCzHF1YybkswgxrekfrQAYnw80QyDW6EGJ7RCT6EhDi/UDLuTDYHbfGvNPXEt3t8W6cS6YXC9DFUtQBt82KFubMdBPK0VegoNGjxHM+xKMkQZuMe31tzT+U7nvsTwYXLvgPfiWjzft97coxnvcxiqdqLBM31rzT1Uvfp0zbDDYUV+v2+tuae3t3cfYtzgYMYnS5cv3c+33tyjDd7pMFQNEYfn+9aae3oq3SeSgb8cescjvrXmn9FgnmZ83WEB+LlsrbcAXcFbks2A4Z4KXtoKPYUmKkfHksHfHdYcT/jWWgjIpkaSNw6/6hrsWuBba+4hg9c5zKpGdBWu8q019wDDQm3gF4f3HM/51loIiHGlQ+/41gYbfGvNPVRBcOgZo5HBkm+tuSeuxYdqg985GNLnW2tQ9NQh7Vlz/BhyeLhvrbknMnjljKnD8aZMGPnWmnu6BrsWaINfOvSOqm+thUC7pA4NbIkGo6N9a809xHCJS+rQLhR9a809JcfUoTbwqm+thUAbfCzRDIY/o3LpON9ac48y6jxt4J/koUot8a21KFGejx16x9uZTB3aWGXE4Q3E+KRmfECV1aKgjSEDvQ5mbNNVfVKQNez4SgwbJ93MbptfCtoQXdFnu6QO7SnaIItohjdmeMpeaKdITFyL5091QnYKMzbY2E+QNXRVH59cFOFNu2kXtAHEsMxhqNphA3FBFlFGXeSwoLLvnDfaKE0WUofEsCzIKnFt8RGOq1ybWfpJGXVBW6cODb6f+YC0rRNOvaTe/qYK6lZrjAzc7jBU7YpWhmcFWSeuxQeRwTWupowdAWN1d7ulDonhwSAvjM9eEndMJxX75XaB1mxtZHCtgxmfttNssGHYJ9+1poy3tc0MCpBRSxymuEO+altLoAr2OM1mJjydzdi8ixxTh5rh0SDvRGW82DHX9N9T+r2udJ/bSA3E+JLDsLm5MAHpHg5PsYnwFMV+m+awuxG/HbG6NnmKC8PEcFlQJOrrFFyfoqcMzfWQPQ3QkU69k+GpoLBv5QxW0szANOPTs91L0gzGwYyvi/3Jvfqhl4dSTYsZV9k1TpqfiYwKHa47Ehnsat7NZgjFcLPbW7r/x/l341rpqAanDp9v/p1mCBvft++pUxT7L1RZnZF0XTKwwmGo+kH368Nac6cZwh6qT/wc3t415TdVUVfMPXWoVGvvNEOML9w+SlFTdtrXxJOvA6vhYNuLHK4x4OdOMxbhJIOrU5gyYicHE69BDM849LBfXWtR4bEbky5/Ku3d+uxmoGvqUDNcU/g/Oi32c9xpNib12Nlx2OzQq1aJGbNEM5D96FfK3jI6rWkGtqDBY8SQOX7HkBh+boQh0RSTAGEW4CCe7PTpVTNjWyN/fgOxx8bIwLpZmrHVRpTEkCZEVMngQHpDwlvFjGZvTHLySrzeYF0mA9JZQ3F4Y2Im187QqnSqb62FIbJ7Vgb+mHZWZeAu3xoLhyqrRVPvXUG/DFWeiGtxh40cESOPJScrCL60CIIgCIIgCIIgCIIgCIIgBO3Iv6h8/J8BCVIQAAAAAElFTkSuQmCC"/>
                            </defs>
                          </svg>
                        </button>
                    </div>

                    <div class=" " :class="['link-row input-row form-group ', {invalid: (!$v.phone.required && submitPhone)}]">

                        <div class="link-text" style="">
                            <input
                            v-model="phone"
                            type="text"
                            class="form-control client-input phone-input"
                            placeholder="Номер телефону"
                            v-mask="'+38 (###) ###-##-##'"
                             >
                        </div>

                        <button @click="sendPhone()" class="btn-icon" v-loading="loadingPhone">
                          <svg v-if="!isSendPhone" data-v-87891006="" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><rect data-v-87891006="" width="25" height="25" fill="url(#pattern0_88_2836)"></rect><defs data-v-87891006=""><pattern data-v-87891006="" id="pattern0_88_2836" patternContentUnits="objectBoundingBox" width="1" height="1"><use data-v-87891006="" xlink:href="#image0_88_2836" transform="scale(0.01)"></use></pattern><image data-v-87891006="" id="image0_88_2836" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD2klEQVR4nO3dT4gcRRQG8DIbiRLiPwTZJGTZqdfzaua9rj3MJQZ0vXnS2972YvakF/UQJSR6USEQTwqCnhIVvHnLRbx5y0EI5KQ5KaKYIKtRDNFNQhkG1mVqd2d6evrtzPeDOSzMNN39bVV1V3dVOQcAAAAAAGBQt9t9goK+5YN8VrCcSn83vU8zK518H/QaBb3b//igv/ug7yCYBhQsZzeHgWAa5oN8ngsEJaYBFMo3dwoEwUxQCGHes9zebSj/tTGsNz3LObQxNSGWL4cJBMHUzLM8P0ogCKY+DxDrd1VCQVU2ZtSRN6oGgsZ/jNrt9pM+6K3B//nyFbG8Siy/oMRMELF+kQnkn6JYOhJjPIhgJsizPLdNCXi7/z0EM0HEenVwuyA/Orcyt/m7CGYCKMhr+auo7ouDfoNgarSwtPQYsfw1MBSWS9v9FsHUhFgvZErJRrsdF3f6PYIZMx/06W0a9/d2ux0EM0ae9dvB1Zb+3Ov1HhxmWwhmDKgtL2dLCZcro2wz4j5mdMx8yAf9I9O4f11h0w7BjIiCfJwpJXcWQ2xXCSVBMEMqClnKN+7yvhuTiKps9yjo5UxX+42FhYWHxhVKgmB2gTqyli0lbV11NYgoMXlHjx5/mFh+y4TyTR2B9CGYDAryQa6UtLgsXc0iSsz/FYV00pVV5hL4w7oD6UMwm6TqKXO1tZ5OlJugiBKT7tx1Ndu4d2RtkoH0zXQwRHTAB/k1c5CXm9y3OKvBUNDz2YMLZa/p/YuzFgyR+Hzjrp84I+IsBZM6FgcfjPxJRI84Q+IsBJO63rfp33rFGRSnOZjl5eX9PuhPmUCuOMPitAZDQd/N77yccMbFaQum1e0eoyD/Zhr3i26PiNMUTHolKLPDf6f+raIoW5P6MPNh59y+ik9HT/ug14cKxtLgWGJ5YZidr/vjg14rOuWzVY6pSjDE+pJr1socsf7QdBC05cQsqj5V9chGDOZO0SmfcU1Kkw00HQLV2K82bDA+6EeuSSYDYT05o4HYq7IoyHqDVdZGo1WWtUadWL+vekL2dKNu6bI3hDCfBq7O7GUvbgzV1o0huk66NoJI0LloDLrfjcEDKkPwCNcYvORgCF4DMgYvyhmDV0kNwcvWxmA4giEYsGMMhrQZg0GfhmBYtDGYOMAQTK1hDCafMQbTMxmCCcyMwRR/hmASTGMwTawxmEjZEEw1bgwm4zcEy1UYgwVdbMGSR5ZgUTBjsGyeIVhY0pi0XPeeGzE0zYj1UwRhiGc5gxJhyLGyfHzrKp+omhrWavUeTaNQ77/U0H0dbQQAAAAAAICbGvcAAaOp6BYsyYQAAAAASUVORK5CYII="></image></defs></svg>

                          <svg v-if="isSendPhone" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <rect width="25" height="25" fill="url(#pattern0_89_3028)"/>
                            <defs><pattern id="pattern0_89_3028" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_89_3028" transform="scale(0.01)"/></pattern>
                              <image id="image0_89_3028" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFfElEQVR4nO2caYgcRRTHO8Y7K15REbwVhXigKB54LCgbxu33ql6vNHiAYsQgeKEQBEFXEfygoigKBuKuuzOvJkxAMRKJVwz54okohpgPnnhLPGJMSNzsrtTOajbL7nb17szUdPf7QX3t+ff8u+pVVf+rg0AQBEEQBEEQBEEQBEEQBEEQBEEQhGxReq10ADHeQQZfJoZXiOHeuBZ3+NZVSOJa3KEZPyCDoxObZtwEDAt96yscZLBvshl7TIEXfesrFFSFxcQ4Mp0hxLg9GA3m+dZZCNQKdYg2+M20ZtQNGbmpv/NA31oLgWZ8dkYz6nXkM986C4GuhpdrA8OJhlThet9aCzHF1YybkswgxrekfrQAYnw80QyDW6EGJ7RCT6EhDi/UDLuTDYHbfGvNPXEt3t8W6cS6YXC9DFUtQBt82KFubMdBPK0VegoNGjxHM+xKMkQZuMe31tzT+U7nvsTwYXLvgPfiWjzft97coxnvcxiqdqLBM31rzT1Uvfp0zbDDYUV+v2+tuae3t3cfYtzgYMYnS5cv3c+33tyjDd7pMFQNEYfn+9aae3oq3SeSgb8cescjvrXmn9FgnmZ83WEB+LlsrbcAXcFbks2A4Z4KXtoKPYUmKkfHksHfHdYcT/jWWgjIpkaSNw6/6hrsWuBba+4hg9c5zKpGdBWu8q019wDDQm3gF4f3HM/51loIiHGlQ+/41gYbfGvNPVRBcOgZo5HBkm+tuSeuxYdqg985GNLnW2tQ9NQh7Vlz/BhyeLhvrbknMnjljKnD8aZMGPnWmnu6BrsWaINfOvSOqm+thUC7pA4NbIkGo6N9a809xHCJS+rQLhR9a809JcfUoTbwqm+thUAbfCzRDIY/o3LpON9ac48y6jxt4J/koUot8a21KFGejx16x9uZTB3aWGXE4Q3E+KRmfECV1aKgjSEDvQ5mbNNVfVKQNez4SgwbJ93MbptfCtoQXdFnu6QO7SnaIItohjdmeMpeaKdITFyL5091QnYKMzbY2E+QNXRVH59cFOFNu2kXtAHEsMxhqNphA3FBFlFGXeSwoLLvnDfaKE0WUofEsCzIKnFt8RGOq1ybWfpJGXVBW6cODb6f+YC0rRNOvaTe/qYK6lZrjAzc7jBU7YpWhmcFWSeuxQeRwTWupowdAWN1d7ulDonhwSAvjM9eEndMJxX75XaB1mxtZHCtgxmfttNssGHYJ9+1poy3tc0MCpBRSxymuEO+altLoAr2OM1mJjydzdi8ixxTh5rh0SDvRGW82DHX9N9T+r2udJ/bSA3E+JLDsLm5MAHpHg5PsYnwFMV+m+awuxG/HbG6NnmKC8PEcFlQJOrrFFyfoqcMzfWQPQ3QkU69k+GpoLBv5QxW0szANOPTs91L0gzGwYyvi/3Jvfqhl4dSTYsZV9k1TpqfiYwKHa47Ehnsat7NZgjFcLPbW7r/x/l341rpqAanDp9v/p1mCBvft++pUxT7L1RZnZF0XTKwwmGo+kH368Nac6cZwh6qT/wc3t415TdVUVfMPXWoVGvvNEOML9w+SlFTdtrXxJOvA6vhYNuLHK4x4OdOMxbhJIOrU5gyYicHE69BDM849LBfXWtR4bEbky5/Ku3d+uxmoGvqUDNcU/g/Oi32c9xpNib12Nlx2OzQq1aJGbNEM5D96FfK3jI6rWkGtqDBY8SQOX7HkBh+boQh0RSTAGEW4CCe7PTpVTNjWyN/fgOxx8bIwLpZmrHVRpTEkCZEVMngQHpDwlvFjGZvTHLySrzeYF0mA9JZQ3F4Y2Im187QqnSqb62FIbJ7Vgb+mHZWZeAu3xoLhyqrRVPvXUG/DFWeiGtxh40cESOPJScrCL60CIIgCIIgCIIgCIIgCIIgBO3Iv6h8/J8BCVIQAAAAAElFTkSuQmCC"/>
                            </defs>
                          </svg>
                        </button>
                    </div>

                   <div class="d-flex justify-content-center prop-submit" style="">
                       <button v-on:click="clearPropositions()" type="button" class="btn prop-button btn-blue">
                           Завершити
                       </button>
                   </div>
               </div>
           </div>

           <div v-if="isMobile" class="prop-arrow-down" v-on:click="showMobilePropositions()">
               <img v-if="!showMobileBlock" src="../../../../public/images/insurance/issue/arrow-down.svg"
                    alt="">
               <img v-if="showMobileBlock" src="../../../../public/images/insurance/issue/arrow-up.svg"
                    alt="">
           </div>

        </div>
    </div>
</template>



<script>
import { PRIVILEGE_REQUIRED_MODULES } from '@/shared/config/insurance-modules';
import { saveClient, getData } from '@/api/client';
import { saveClientPropositions, sendMailPropositions, sendPhonePropositions } from '@/api/link';
import { InsuredsListItem } from '@/views/osago/components';
import Multiselect from "vue-multiselect";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import {
    companyMixin,
    customerMixin,
    documentMixin
} from "../../../mixin";
import {email, maxLength, minLength, numeric, required, requiredIf} from "vuelidate/lib/validators";
    export default {
        mixins: [customerMixin, companyMixin, documentMixin],
        components: {
            InsuredsListItem,
        },
        props: {
            propositionList: {
                type: Array,
                default: function () { return [] }
            },
            isMobile: {
                type: Boolean,
                default: false,
            },
            showPropositionModal: {
                type: Boolean,
                default: false,
            },
            productType: {
                type: Number,
                default: 1,
            },
            searchParamsData: {
                type: Object,
                default: null,
            },
            dateInfoData: {
                type: Object,
                default: null,
            }
        },
        data: () => ({
            privilegeList: [],
            userTypeList: [],
            show: true,
            insuredsList: [],
            isLoadInsuredsList: false,
            showPropositions: true,
            showClientForm: false,
            showMobileBlock: false,
            showLink: false,
            clientId: null,
            clientName: null,
            comment: null,
            qrcode: null,
            link: null,
            linkId: null,
            email: null,
            phone: null,
            submitEmail: false,
            submitPhone: false,
            submitCheck: false,
            isCopied: false,
            isSendMail: false,
            isSendPhone: false,
            loadingMail: false,
            loadingPhone: false,
        }),

        validations: {
            clientName: {required: requiredIf(function (nestedModel) {
                    return ! this.comment
                }), minLength: minLength(2)},
            comment: {required: requiredIf(function (nestedModel) {
                    return ! this.clientName
            }), minLength: minLength(2), maxLength: maxLength(80)},
            email: {required: requiredIf(function (nestedModel) {
                    return this.showLink && !this.phone
                }), email},
            phone: {required: requiredIf(function (nestedModel) {
                    return this.showLink && !this.email
                })},
        },

        watch: {
            'clientName': async function(newValue, oldValue) {
                if (newValue && newValue.length >= 3) {
                    this.isLoadInsuredsList = true;
                    await this.fetchClients(newValue,'surname');
                } else {
                    // this.insuredsListBySurname = [];
                    // this.isLoadInsuredsListBySurname = false;
                }
            },
            propositionList(newValue, oldValue) {
                if (newValue.length == 0) {
                    this.showClientForm = false;
                    this.showPropositions = true;
                }
            }
        },

        created() {
            this.privilegeList = this.$store.getters.CUSTOMER_PRIVILEGE;
            this.userTypeList = this.$store.getters.CUSTOMER_TYPES;
        },

        computed: {
            policyInfo() {
                return this.searchParamsData;
            },
            dateInfo() {
                return this.dateInfoData;
            },
            userType(){
                let userType;
                if(this.policyInfo.customerPrivilege == 2){
                    this.privilegeList.forEach((item) => {
                        if(item.id === this.policyInfo.customerPrivilege){
                            userType = item.value;
                        }
                    });
                }else{
                    this.userTypeList.forEach((item) => {
                        if(item.id === this.policyInfo.customerType){
                            userType = item.value;
                        }
                    });
                }

                return userType;
            },
        },

        methods: {
            selectInsuredInfo(insured) {
                this.isfillData = true;
                this.selectedPibInn = insured;
                this.clientId = insured.id;

                let selectDocument = false;
                let selectVehicle = false;
                const clientData = insured;
                // insured.documents = this.getAllowedDocumentsTypes(insured.documents);
                // if(insured.documents.length == 1){
                //     selectDocument = insured.documents[0];
                // }

                if(insured.vehicles.length == 1){
                    selectVehicle = insured.vehicles[0];
                }
                let params = {
                    "selectPibInn" : insured,
                    "selectVehicle" : selectVehicle,
                    "selectTourists" : false,//insured.selectTourists,
                };
                if(!this.isLegalType){
                    params["selectDocument"] = selectDocument;
                }

                this.insuredsList = [];
                this.clientId = clientData.id;
                //this.$store.commit('SET_CLIENT', clientData.id);
                let fio = clientData.fio.split(" ");
                if (this.isLegalType) {
                    this.clientName = clientData.fio;
                }else{
                    this.clientName = clientData.fio;//fio[0];
                }
            },
            async fetchClients(query, type) {
                if (!query) {
                    this.isLoadInsuredsList = false;
                    return;
                }
                this.insuredsList = [];
                let params = {
                    "requestType": "clientsByUserId",
                    "searchText": query,
                    //"customerType":this.orderData?.requestData?.customerType
                };
                //console.log(params)
                clearTimeout(this.fetchClientsTimeout);
                this.fetchClientsTimeout = setTimeout(async () => {
                    let response = await getData(params);
                    //console.log('response', response)
                    this.insuredsList = response.data.data.items;
                    // if(type == "identificationCode"){
                    //     this.insuredsList = response.data.data.items;
                    // }
                    // else if (type == "erdpyCode"){
                    //     this.insuredsListByErdpyCode = response.data.data.items;
                    // }
                    //  if (type == "surname"){
                    //      this.insuredsList = response.data.data.items;
                    // }
                    // else if (type == "name"){
                    //     this.insuredsListByCompanyName = response.data.data.items;
                    // }
                    this.isLoadInsuredsList = false;
                    // this.isLoadInsuredsByErdpyCode = false;
                    // this.isLoadInsuredsByCompanyName = false;
                    // this.isLoadInsuredsListBySurname = false;
                }, 1000);
            },
            removeProposition(proposition) {
                this.$emit('remove-proposition', proposition);
            },
            clearPropositions() {
                this.submitCheck = false;
                this.showLink = false;
                this.showMobileBlock = false;
                this.resetFormData();
                this.$emit('clear-propositions');
            },
            goNext() {
                this.showClientForm = true;
                this.showPropositions = false;
            },
            generateLink() {
                this.submitCheck = true;
                if (this.$v.$invalid) {
                    // this.scrollToErrors();
                    return false;
                }
                this.showClientForm = false;
                this.showLink = true;

                let autolawyerList = this.propositionList[0].listAutolawyer;

                let currentSearchParams = JSON.parse(JSON.stringify(this.policyInfo || {}));

                let modifiedPropositionsList = this.propositionList.map(proposition => {
                    let prop = JSON.parse(JSON.stringify(proposition));
                    prop.requiresPrivilegeDocument = PRIVILEGE_REQUIRED_MODULES.includes(prop.moduleName) && parseInt(currentSearchParams.customerPrivilege) !== 1;
                    return prop;
                });

                if (!this.clientId && this.clientName) {
                    let parts = this.clientName.trim().split(/\s+/).slice(0, 3);
                    if (!currentSearchParams.customer) {
                        currentSearchParams.customer = {};
                    }
                    if (parts[0]) currentSearchParams.customer.surname = parts[0];
                    if (parts[1]) currentSearchParams.customer.name = parts[1];
                    if (parts[2]) currentSearchParams.customer.patronymic = parts[2];
                }

                let params = {
                    propositionsList: modifiedPropositionsList, //this.propositionList, //.map(proposition => proposition.offerId),
                    clientId: this.clientId,
                    comment: this.comment,
                    requestType: 'clientProposition',
                    searchParams: currentSearchParams,
                    dateInfo: this.dateInfo,
                    productType: this.productType,
                }

                saveClientPropositions(params).then(response => {
                    //console.log('saveLink response', response)
                    if (response?.data?.status === 'success') {
                        this.qrcode  = response?.data?.data?.qrcode;
                        this.link  = response?.data?.data?.link;
                        this.linkId  = response?.data?.data?.linkId;
                        this.email  = response?.data?.data?.clientEmail;
                        this.phone  = response?.data?.data?.clientPhone;

                        return true;
                    }

                    this.$alert("При збереженні виникла проблема, спробуйте знову!", '', 'error');
                }).catch(err => {
                    console.log(err);
                    this.$alert("При збереженні виникла проблема, спробуйте знову!", '', 'error');
                });
            },
            resetFormData() {
                this.clientId = null;
                this.clientName = null;
                this.comment = null;
                this.email = null;
                this.phone = null;
            },
            copyToBuffer: function() {
                navigator.clipboard.writeText(this.link);
                this.isCopied = true;
                setTimeout(() => {
                    this.isCopied = false;
                }, 1000)
            },
            sendMail() {
                this.submitEmail = true;
                if (this.$v.$invalid) {
                    return false;
                }
                this.loadingMail = true;

                let params = {
                    propositionsList: this.propositionList,
                    clientId: this.clientId,
                    email: this.email,
                    link: this.link,
                    linkId: this.linkId,
                    dateInfo: this.dateInfo,
                }

                sendMailPropositions(params).then(response => {
                    this.loadingMail = false;
                    console.log('saveLink response', response)
                    console.log('response?.data?.status', response?.data?.status, (response?.data?.status === 'success'))
                    if (response?.data?.status === 'success') {
                        //this.$message("Успіх! Пропозиції надіслано клієнту.");
                        this.isSendMail = true;
                        this.submitEmail = false;
                        setTimeout(() => { this.isSendMail = false; }, 5000);
                        return true;
                    }
                    this.$error("Під час відправки пошти виникла проблема, спробуйте знову!", '', 'error');
                }).catch(err => {
                    this.loadingMail = false;
                    this.submitEmail = false;
                    this.isSendMail = true;
                    setTimeout(() => {
                        this.isSendMail = false;
                    }, 1000)
                    console.log(err);
                    this.$error("Під час відправки пошти виникла проблема, спробуйте знову!", '', 'error');
                });
            },
            sendPhone() {
                this.submitPhone = true;
                if (this.$v.phone.$invalid) {
                    return false;
                }
                this.loadingPhone = true;

                let params = {
                    propositionsList: this.propositionList,
                    clientId: this.clientId,
                    phone: this.phone,
                    link: this.link,
                    linkId: this.linkId,
                    dateInfo: this.dateInfo,
                }

                sendPhonePropositions(params).then(response => {
                    this.loadingPhone = false;
                    if (response?.data?.status === 'success') {
                        this.isSendPhone = true;
                        this.submitPhone = false;
                        setTimeout(() => { this.isSendPhone = false; }, 5000);
                        return true;
                    }
                    this.$error("Під час відправки повідомлення виникла проблема, спробуйте знову!", '', 'error');
                }).catch(err => {
                    this.loadingPhone = false;
                    this.submitPhone = false;
                    this.isSendPhone = true;
                    setTimeout(() => {
                        this.isSendPhone = false;
                    }, 1000)
                    console.log(err);
                    this.$error("Під час відправки повідомлення виникла проблема, спробуйте знову!", '', 'error');
                });
            },
            showMobilePropositions() {
                this.showMobileBlock = !this.showMobileBlock;
            },
            goBack() {
                this.$emit('close-propositions-modal');
            },
            showFranchise(franchise) {
                if (franchise == 'all') {
                    return 'Всі франшизи'
                } else {
                    return `${franchise} грн`
                }
            },
            scrollTo(item){
                let el = item;
                $('html,body').animate({
                    scrollTop: $(el).offset().top + 150
                }, 1000);
            },
        }
    }
</script>
<style scoped>

</style>
